var roundedCornersMixin = {
    data: function () {
        return {
            product: {
                roundedCorners: {
                    bottomLeftRadius: 0,
                    bottomRightRadius: 0,
                    topLeftRadius: 0,
                    topRightRadius: 0
                }
            }
        }
    }
}